import { render, staticRenderFns } from "./medium.pug?vue&type=template&id=019bfee6&scoped=true&lang=pug&"
import script from "./ProductMedium.vue?vue&type=script&lang=js&"
export * from "./ProductMedium.vue?vue&type=script&lang=js&"
import style0 from "./ProductMedium.vue?vue&type=style&index=0&id=019bfee6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019bfee6",
  null
  
)

/* custom blocks */
import block0 from "./ProductMedium.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports